export default __webpack_public_path__ + "static/media/menu-black.31976bc8.svg";